import { AUTH_RESET, AUTH_SET_TOKEN, AuthAction } from 'actions/auth/AuthActionsTypes';
import { AuthState } from 'reducers/auth/AuthState';
import { Reducer } from 'redux';

const initialState: AuthState = {
    token: undefined
};

export const authReducer: Reducer<AuthState, AuthAction> = (state = initialState, action) => {
    switch (action.type) {
        case AUTH_RESET:
            return {
                ...initialState
            };

        case AUTH_SET_TOKEN:
            return {
                ...state,
                token: action.payload.token
            };

        default:
            return state;
    }
};
